import { createElementBlock, openBlock, createElementVNode } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "stroke-width": "1.5",
  viewBox: "0 0 24 24"
};
function render(_ctx, _cache) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    createElementVNode("path", {
      fill: "none",
      stroke: "currentColor",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      d: "M21.8 17.583V6.425a1.55 1.55 0 0 0-.854-1.383L12.691.913a1.55 1.55 0 0 0-1.381 0l-8.258 4.12A1.55 1.55 0 0 0 2.2 6.416v11.159a1.55 1.55 0 0 0 .854 1.383l8.258 4.129a1.55 1.55 0 0 0 1.382 0l8.257-4.121a1.55 1.55 0 0 0 .849-1.383"
    }, null, -1)
  ]));
}
const basicShapeHexagon = { render };
export {
  basicShapeHexagon as default,
  render
};
//# sourceMappingURL=basic-shape-hexagon.svg.js.map
